/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {permissions} from '../../../permissions';
import {OrderHeadersService} from '../../../services/order-headers.service';
import {OrderLineService} from '../../../services/order-line.service';
import {ConfirmationService} from 'primeng/api';
import {environment} from '../../../../environments/environment';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-order-headers-reject',
    templateUrl: './order-headers-reject.component.html',
    styleUrls: ['./order-headers-reject.component.scss'],
    providers: [
        OrderHeadersService,
        OrderLineService
    ]
})
export class OrderHeadersRejectComponent implements OnInit {

    @ViewChild('myTable')   table: any;

    public loading = false;
    public  permissions = permissions;

    po: any = [];
    rows = [];
    selected = [];
    cols = [];
    totalRecords = 0;

    private PO1_ID: any;
    private units: Array<any> = [];

    private errors = [];

    public headerStatuses = this.orderHeadersService.getStatuses();
    public refOrderHeadersService = OrderHeadersService;

    private lineStatuses = this.orderLineService.getStatuses();
    private refOrderLineService = OrderLineService;
    public ban = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private orderHeadersService: OrderHeadersService,
        private orderLineService: OrderLineService,
        private toastr: ToastrService,
        private confirmationService: ConfirmationService,
        private title: Title
    ) {
        this.title.setTitle('EDI - Purchase Order');
    }

    ngOnInit() {

        this.cols = [
            { field: 'PO2_LINE',
                align: 'left',
                bigScreen:   {header: 'Line #', visible: true, width: '65px'},
                smallScreen: {header: 'Line#',  visible: true, width: '50px'} },
            { field: 'PO2_STATUS',
                align: 'left',
                bigScreen:   {header: 'Status', visible: true,  width: '110px'},
                smallScreen: {header: 'Status', visible: false, width: '110px'} },
            { field: 'ITEM_INFO_COMBINE',
                align: 'left',
                bigScreen:   {header: 'Item Info', visible: false, width: '140px'},
                smallScreen: {header: 'Item Info', visible: true,  width: '100%'} },
            { field: 'ITEM_INFO',
                align: 'left',
                bigScreen:   {header: 'Item Info', visible: true,  width: '35%'},
                smallScreen: {header: 'Item Info', visible: false, width: '140px'} },
            { field: 'PO2_DESCRIPTION',
                align: 'left',
                bigScreen:   {header: 'Item Desc', visible: true,  width: '30%'},
                smallScreen: {header: 'Item Desc', visible: false, width: '140px'} },
            { field: 'PO2_QUANTITY',
                align: 'right',
                bigScreen:   {header: 'Quantity', visible: true, width: '14%'},
                smallScreen: {header: 'Qty',      visible: true, width: '95px'} },
            { field: 'PO2_UNIT_PRICE',
                align: 'right',
                bigScreen:   {header: 'Unit Price', visible: true, width: '13%'},
                smallScreen: {header: 'Unit Price', visible: true, width: '95px'} },
            { field: 'EXT_VAL',
                align: 'right',
                bigScreen:   {header: 'Ext Value', visible: true, width: '13%'},
                smallScreen: {header: 'Ext Val',   visible: true, width: '95px'} },
            { field: 'PO1_CURRENCY',
                align: 'none',
                bigScreen:   {header: 'Currency', visible: true, width: '13%'},
                smallScreen: {header: 'Currency',   visible: true, width: '95px'} },
            { field: 'UM1_NAME',
                align: 'left',
                bigScreen:   {header: 'Unit of Measure', visible: true, width: '14%'},
                smallScreen: {header: 'UM',              visible: true, width: '65px'} }
        ];
        this.onWindowResize();

        this.po.PO1_ID = this.route.snapshot.params.id;
        this.po.HASH   = this.route.snapshot.params.hash;
        this.PO1_ID    = this.po.PO1_ID || this.po.HASH;

        this.orderLineService.preloadData(false).subscribe(data => {
            this.units = data.units.map(unit => {
                return {
                    UM1_ID   : unit.UM1_ID,
                    UM1_NAME : unit.UM1_NAME
                };
            });
            this.getData(this.PO1_ID);
        });
    }

    getData(id) {
        this.loading = true;
        this.orderHeadersService.getById(id).subscribe(res => {
            this.ban = false;
            this.po = res.data;
            res.lines.forEach(line => {
                line.UM1_NAME = this.getUnitName(line.UM1_ID_NEW);
                line.PO1_CURRENCY = this.po.PO1_CURRENCY;
                if (line.PO2_STATUS > this.refOrderLineService.STATUS_ACKNOWLEDGED) {
                    this.ban = true;
                }
            });
            this.rows = res.lines;
            // this.selected = res.lines;
            this.totalRecords = this.rows.length;
            this.loading = false;
        }, error => {
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toastr.error('TimeOut occured', 'Service Error', {
                timeOut: 3000,
            });
        });
    }

    getUnitName(id) {
        const unit = this.units.find(unitsItem => unitsItem.UM1_ID == id);
        return (unit == undefined) ? '' : unit.UM1_NAME;
    }

    onCancel() {
        this.router.navigate(['order-headers/' + this.PO1_ID]);
    }

    onSelectionChange(event) {
        this.selected = this.selected.filter(selection => selection.PO2_STATUS <= this.refOrderLineService.STATUS_ACKNOWLEDGED);
    }

    onWindowResize() {
        this.cols.forEach(col => {
            const isBigScreen = window.innerWidth >= environment.smallScreenThreshold;
            col.visible = isBigScreen ? col.bigScreen.visible : col.smallScreen.visible;
            col.header = isBigScreen ? col.bigScreen.header : col.smallScreen.header;
            col.width = isBigScreen ? col.bigScreen.width : col.smallScreen.width;
        });
    }

    selectionReject() {
        if (this.selected && this.selected.length) {
            this.confirmationService.confirm({
                header: 'Rejection Action',
                message: 'Are you sure to Reject selected lines?',
                accept: () => {
                  this.orderHeadersService.rejectLines( this.po.PO1_ID, this.selected ).subscribe( result => {
                    if (result.success) {
                      this.errors = [];
                        this.toastr.success('Rejection action successful.');
                      this.router.navigate(['order-headers/' + this.PO1_ID]);
                    } else {
                      this.errors = result.errors;
                      this.po = result.po;
                      result.lines.forEach(rejectedLine => {
                        this.rows.find(rowsItem => rowsItem.PO2_ID == rejectedLine.PO2_ID).PO2_STATUS = rejectedLine.PO2_STATUS;
                        this.selected.find(selectedItem => selectedItem.PO2_ID == rejectedLine.PO2_ID).PO2_STATUS = rejectedLine.PO2_STATUS;
                      });
                      this.toastr.error('Errors in some lines.', 'Result');
                    }
                  });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/order-headers/order-headers-reject/order-headers-reject.component.ts